var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "correction-application"
  }, [_c("a-card", {
    staticClass: "top-half"
  }, [_c("div", {
    staticClass: "top-title"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        _vm.personnelEntryVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("人员录入")))]), _c("a-button", {
    staticClass: "marginR15",
    staticStyle: {
      "background-color": "#11a265",
      color: "#fff"
    },
    on: {
      click: function ($event) {
        _vm.importVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("批量录入")))]), _c("span", {
    staticClass: "up-tip"
  }, [_c("a-icon", {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      type: "exclamation-circle"
    }
  }), _vm._v(_vm._s(_vm.$t("单次批改申请提交人数上限为2000条")))], 1), _c("div", {
    staticClass: "effect-time"
  }, [_c("span", {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("生效时间")) + ":  ")]), _c("a-date-picker", {
    staticClass: "marginR15",
    staticStyle: {
      width: "200px"
    },
    attrs: {
      format: "YYYY-MM-DD",
      placeholder: _vm.$t("选择日期"),
      disabledDate: _vm.disabledDate,
      valueFormat: "YYYY-MM-DD",
      allowClear: false,
      getCalendarContainer: triggerNode => triggerNode.parentNode,
      disabled: _vm.correctionDataSource.length > 0
    },
    on: {
      change: _vm.searchInsuredList
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }), _c("svg-icon", {
    staticStyle: {
      "margin-right": "10px",
      cursor: "pointer"
    },
    attrs: {
      icon: "modificationDate",
      size: 18,
      color: _vm.correctionDataSource.length > 0 ? "#ccc" : "#1890ff"
    },
    nativeOn: {
      click: function ($event) {
        return _vm.openChange.apply(null, arguments);
      }
    }
  }), _c("a-button", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      type: "primary",
      loading: _vm.sureLoading
    },
    on: {
      click: _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 1), _vm.correctionDataSource.length == 0 ? _c("div", {
    staticClass: "empty-tip"
  }, [_vm._v(_vm._s(_vm.$t("暂未添加批改人员,请选择添加")))]) : _c("a-table", {
    staticClass: "correct-table change-height",
    attrs: {
      dataSource: _vm.correctionDataSource,
      rowClassName: _vm.rowClassName,
      pagination: _vm.correctionPagination,
      columns: _vm.correctionColumns,
      expandedRowKeys: _vm.expandedRowKeys,
      rowKey: "rowKey",
      scroll: {
        x: 1200,
        y: 470
      }
    },
    on: {
      change: _vm.handlerCorrectionTableChange,
      expandedRowsChange: _vm.expandedRowsChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record, index) {
        return [record.type === _vm.ADD ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.deletePersonnel(index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e(), record.type === _vm.REDUCE || record.type === _vm.REPLACE ? _c("a-button", {
          staticClass: "marginR15 revoke-btn",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.reduceRevoke(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("撤回")))]) : _vm._e(), record.type === _vm.ADD || record.type === _vm.REPLACE ? _c("a-button", {
          staticClass: "marginR15 add-edit",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.editPersonnel(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e()];
      }
    }, {
      key: "expandedRowRender",
      fn: function (record) {
        return record.errorMessage && record.errorMessage.length ? _vm._l(record.errorMessage, function (item) {
          return _c("span", {
            key: item,
            staticClass: "err-line"
          }, [_vm._v(_vm._s(_vm._f("translate")(_vm.$t(item))))]);
        }) : undefined;
      }
    }], null, true)
  }, _vm._l(_vm.correctionColumns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1), _c("div", {
    staticClass: "diliver-bg"
  }), _c("a-card", {
    staticClass: "bottom-half"
  }, [_c("div", {
    staticClass: "search-form"
  }, [_c("a-input", {
    staticClass: "marginR15 search-input",
    attrs: {
      placeholder: _vm.$t("姓名")
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _c("a-input", {
    staticClass: "marginR15 search-input",
    attrs: {
      placeholder: _vm.$t("证件号码")
    },
    model: {
      value: _vm.idNumber,
      callback: function ($$v) {
        _vm.idNumber = $$v;
      },
      expression: "idNumber"
    }
  }), _c("a-input", {
    staticClass: "marginR15 search-input",
    attrs: {
      placeholder: _vm.$t("备注")
    },
    model: {
      value: _vm.remark,
      callback: function ($$v) {
        _vm.remark = $$v;
      },
      expression: "remark"
    }
  }), _c("a-button", {
    staticClass: "marginR15",
    staticStyle: {
      width: "100px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.searchInsuredList
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    staticStyle: {
      width: "100px"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))])], 1), _c("a-table", {
    staticClass: "change-height",
    attrs: {
      dataSource: _vm.dataSource,
      pagination: _vm.pagination,
      loading: _vm.loading,
      rowKey: record => record.id,
      columns: _vm.columns,
      scroll: {
        x: 1200,
        y: 400
      }
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record, index) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.singlyReduce(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("减员")))]), _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.replacePersonnel(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("替换")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots4, _item$slots5, _item$slots6;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots4 = item.slots) === null || _item$slots4 === void 0 ? void 0 : _item$slots4.title
      },
      slot: (_item$slots5 = item.slots) === null || _item$slots5 === void 0 ? void 0 : _item$slots5.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots6 = item.slots) === null || _item$slots6 === void 0 ? void 0 : _item$slots6.title)))]);
  }), 0)], 1), _vm.personnelEntryVisible ? _c("personnel-entry-model", {
    attrs: {
      policyInfo: _vm.policyInfo,
      effectiveDate: _vm.date,
      policyPurpose: _vm.policyPurpose,
      insurancePlan: _vm.insurancePlan,
      occupationTypeOptions: _vm.occupationTypeOptions,
      dialogVisible: _vm.personnelEntryVisible,
      yearDays: _vm.yearDays,
      professionInfo: _vm.professionInfo
    },
    on: {
      "update:dialogVisible": function ($event) {
        _vm.personnelEntryVisible = $event;
      },
      "update:dialog-visible": function ($event) {
        _vm.personnelEntryVisible = $event;
      },
      personnelEntrySave: _vm.personnelEntrySave
    }
  }) : _vm._e(), _vm.editPersonnelVisible ? _c("edit-personnel-model", {
    attrs: {
      policyPurpose: _vm.policyPurpose,
      insurancePlan: _vm.insurancePlan,
      editPersonnelVisible: _vm.editPersonnelVisible,
      professionInfo: _vm.professionInfo,
      occupationTypeOptions: _vm.occupationTypeOptions,
      editPersonelObj: _vm.editPersonelObj
    },
    on: {
      "update:editPersonnelVisible": function ($event) {
        _vm.editPersonnelVisible = $event;
      },
      "update:edit-personnel-visible": function ($event) {
        _vm.editPersonnelVisible = $event;
      },
      editPersonnelSave: _vm.editPersonnelSave
    }
  }) : _vm._e(), _vm.importVisible ? _c("batch-entry-personel", {
    attrs: {
      policyInfo: _vm.policyInfo,
      yearDays: _vm.yearDays,
      insurancePlan: _vm.insurancePlan,
      policyPurpose: _vm.policyPurpose,
      professionInfo: _vm.professionInfo,
      occupationTypeOptions: _vm.occupationTypeOptions,
      copyInsuredPersonnelList: _vm.copyInsuredPersonnelList,
      importVisible: _vm.importVisible,
      effectiveDate: _vm.date
    },
    on: {
      "update:importVisible": function ($event) {
        _vm.importVisible = $event;
      },
      "update:import-visible": function ($event) {
        _vm.importVisible = $event;
      },
      importSave: _vm.importSave
    }
  }) : _vm._e(), _vm.replacePersonnelVisible ? _c("replace-personnel-model", {
    attrs: {
      professionInfo: _vm.professionInfo,
      replacePersonnelVisible: _vm.replacePersonnelVisible,
      replaceItem: _vm.replaceItem,
      policyInfo: _vm.policyInfo,
      insurancePlan: _vm.insurancePlan,
      occupationTypeOptions: _vm.occupationTypeOptions,
      policyPurpose: _vm.policyPurpose,
      isEditReplace: _vm.isEditReplace,
      yearDays: _vm.yearDays,
      effectiveDate: _vm.date
    },
    on: {
      "update:replacePersonnelVisible": function ($event) {
        _vm.replacePersonnelVisible = $event;
      },
      "update:replace-personnel-visible": function ($event) {
        _vm.replacePersonnelVisible = $event;
      },
      saveReplace: _vm.saveReplace
    }
  }) : _vm._e(), _vm.surePageVisible ? _c("correction-sure", {
    attrs: {
      effectiveDate: _vm.date,
      verifyAt: _vm.verifyAt,
      policyPurpose: _vm.policyPurpose,
      surePageVisible: _vm.surePageVisible,
      correctionData: _vm.correctionDataSource
    },
    on: {
      "update:surePageVisible": function ($event) {
        _vm.surePageVisible = $event;
      },
      "update:sure-page-visible": function ($event) {
        _vm.surePageVisible = $event;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };